import React, { useState } from 'react'
import '../styles/Pricing.css'

const price = `${process.env.PUBLIC_URL}/price.png`
const onlineparkour = `${process.env.PUBLIC_URL}/onlinepriceparkour.png`
const onlineyoga = `${process.env.PUBLIC_URL}/onlinepriceyoga.png`
const corporate = `${process.env.PUBLIC_URL}/corpprice.png`
const group = `${process.env.PUBLIC_URL}/yogaprice.png`

const yoga = `${process.env.PUBLIC_URL}/med.svg`
const parkour = `${process.env.PUBLIC_URL}/park.svg`

const YOGA_PLANS = [
  {
    id: 'yoga-online',
    icon: onlineyoga,
    name: 'Private — Online',
    subtitle: 'Tbilisi & Online',
    pricing: [
      { price: '$40', desc: '1 Online Session' },
      { price: '$150', desc: '4 Sessions (1x weekly)' },
      { price: '$360', desc: '9 Sessions (2x weekly)' },
      { price: '$450', desc: '12 Sessions (3x weekly)' },
    ],
    includes: [
      'Full FYSM ZERO + FYSM 1',
      'Flexibility + strength + balance',
      'Hands-on adjustments',
      'Stress & tension release',
      'Nervous system balancing',
      'Movement freedom & posture',
    ],
  },
  {
    id: 'yoga-inperson',
    icon: price,
    name: 'Private — In Person',
    subtitle: '1h 20m Sessions',
    hot: true,
    pricing: [
      { price: '$55', desc: '1 Session' },
      { price: '$200', desc: '4 Sessions (1x weekly)' },
      { price: '$440', desc: '8 Sessions (2x weekly)' },
      { price: '$555', desc: '12 Sessions (3x weekly)' },
    ],
    includes: [
      'Full FYSM ZERO + FYSM 1',
      'Flexibility + strength + balance',
      'Hands-on adjustments',
      'Stress & tension release',
      'Nervous system balancing',
      'Video montage: +$55 (optional)',
    ],
  },
  {
    id: 'yoga-corporate',
    icon: corporate,
    name: 'Corporate Yoga',
    subtitle: 'Healthier, Focused Teams',
    pricing: [
      { price: '$150', desc: '1 Session (up to 10 ppl)' },
      { price: '$555', desc: '4 Sessions/month (up to 15 ppl)' },
      { price: '$1,111', desc: '8 Sessions/month (up to 20 ppl)' },
    ],
    includes: [
      'FYSM ZERO + FYSM1',
      '80–90 min corporate flow',
      'Hands-on corrections',
      'Stress detox & focus reset',
      'Team energy alignment',
    ],
  },
]

const PARKOUR_PLANS = [
  {
    id: 'pk-private',
    icon: price,
    name: 'Private Sessions',
    subtitle: 'One-on-One Guidance',
    pricing: [
      { price: '₾60', desc: 'Trial Session' },
      { price: '₾220', desc: '4 Sessions — Skill Progression' },
      { price: '₾440', desc: '8 Sessions — Mastery Path' },
    ],
    includes: [
      'Personalized skill progression',
      'Full body mechanics & safety',
      'Mindset coaching & confidence',
      'Step-by-step skill mastery',
      'Progress video: +₾100 (optional)',
    ],
  },
  {
    id: 'pk-group',
    icon: group,
    name: 'Group Sessions',
    subtitle: 'Train Together',
    hot: true,
    pricing: [
      { price: '₾50', desc: 'Per Person (Trio — 3 people)' },
      { price: '₾40', desc: 'Per Person (5+ people)' },
    ],
    includes: [
      'Group-based skill progression',
      'Creative flow exercises',
      'Individualized coaching',
      'Team motivation & support',
    ],
  },
  {
    id: 'pk-online',
    icon: onlineparkour,
    name: 'Online Program',
    subtitle: 'Train From Anywhere',
    pricing: [
      { price: '₾400', desc: 'Complete Mentorship Program' },
      { price: '+₾50', desc: 'Video Call Check-in (optional)' },
    ],
    includes: [
      '5 custom tutorial videos',
      '1 bonus mindset & theory video',
      'Unlimited Q&A & video feedback',
      'Step-by-step progression plan',
      'Lifetime access to materials',
      'Progress montage: +₾100',
    ],
  },
]

const CONTACT = {
  yoga: {
    phone: 'tel:+995558108316',
    phoneLabel: '+995 558 10 83 16',
    telegram: 'https://t.me/makeurselfcomfortable',
    telegramLabel: '@makeurselfcomfortable',
  },
  parkour: {
    phone: 'tel:+995598780220',
    phoneLabel: '+995 598 78 02 20',
    telegram: 'https://t.me/Ninja_Cheff',
    telegramLabel: '@Ninja_Cheff',
  },
}

function PlanCard({ plan }) {
  return (
    <div className="pricing-card">
      {plan.hot && <div className="pricing-hot-badge">Most Popular</div>}

     <div className="pricing-card-header">
  <img src={plan.icon} alt="" className="pricing-icon-img" />
  <div>
    <h3 className="pricing-name">{plan.name}</h3>
    <p className="pricing-sub">{plan.subtitle}</p>
  </div>
</div>
      <div className="pricing-prices">
        {plan.pricing.map((p, i) => (
          <div key={i} className="pricing-price-row">
            <span className="pricing-price">{p.price}</span>
            <span className="pricing-price-desc">{p.desc}</span>
          </div>
        ))}
      </div>

      <div className="pricing-includes">
        <p className="pricing-includes-label">Includes</p>
        <ul className="pricing-includes-list">
          {plan.includes.map((item, i) => (
            <li key={i}>
              <span className="pricing-bullet">→</span>
              {item}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

function Pricing() {
  const [tab, setTab] = useState('yoga')
  const contact = CONTACT[tab]

  return (
    <div className="pricing-body" id='pricing'>
      <div className="pricing-pattern"></div>

      <div className="pricing-container">

        <div className="pricing-header">
          <div className="pricing-badge">PRICING</div>
          <h1 className="pricing-title">Book Now</h1>
          <div className="title-underline"></div>
          <p className="pricing-subtitle">Choose Your Path</p>
        </div>

        <div className="pricing-tabs">
         <button
  className={`pricing-tab ${tab === 'yoga' ? 'active' : ''}`}
  onClick={() => setTab('yoga')}
>
  <img src={yoga} alt="" className="tab-icon" /> Yoga
</button>
<button
  className={`pricing-tab ${tab === 'parkour' ? 'active' : ''}`}
  onClick={() => setTab('parkour')}
>
  <img src={parkour} alt="" className="tab-icon" /> Parkour
</button>
        </div>

        {tab === 'yoga' && (
          <>
            <div className="pricing-grid">
              {YOGA_PLANS.map(plan => <PlanCard key={plan.id} plan={plan} />)}
            </div>

            <div className="pricing-extra-bar">
              <span className="pricing-extra-icon"><img src={group} alt="group session" className='pricing-icon-img' /></span>
              <div className="pricing-extra-info">
                <span className="pricing-extra-name">Group Sessions</span>
                <span className="pricing-extra-note">Studios or outdoor parks · FYSM ZERO + FYSM1 group flow</span>
              </div>
              <div className="pricing-extra-price-wrap">
                <span className="pricing-extra-price">$15</span>
                <span className="pricing-extra-per">per person (₾40)</span>
              </div>
            </div>

            <div className="pricing-instructor">
              Instructor: <strong>Natalie Raizer</strong>
              <span>@mentalformation</span>
            </div>
          </>
        )}

        {tab === 'parkour' && (
          <div className="pricing-grid">
            {PARKOUR_PLANS.map(plan => <PlanCard key={plan.id} plan={plan} />)}
          </div>
        )}

        <div className="pricing-cta">
          <p>Ready to start? Get in touch and we'll set everything up.</p>
         <div className="pricing-cta-btns">
  <a href={contact.phone} className="pricing-btn pricing-btn--primary">
    <svg className="btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 10.8 19.79 19.79 0 01.22 2.18 2 2 0 012.18 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 7.91a16 16 0 006.06 6.06l1.27-.55a2 2 0 012.11.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
    </svg>
    Call
  </a>
  <a href={contact.telegram} target="_blank" rel="noreferrer" className="pricing-btn pricing-btn--ghost">
    <svg className="btn-icon" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.447 1.394c-.16.16-.295.295-.605.295l.213-3.053 5.56-5.023c.242-.213-.054-.333-.373-.12L8.32 14.617l-2.96-.924c-.643-.204-.657-.643.136-.953l11.57-4.461c.537-.194 1.006.131.828.942z"/>
    </svg>
    Message Us
  </a>
</div>
        </div>

      </div>
    </div>
  )
}

export default Pricing